import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'frantinco-room-visualizer-landscape',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './room-visualizer-landscape.component.html',
  styleUrl: './room-visualizer-landscape.component.scss'
})
export class RoomVisualizerLandscapeComponent {
  @Input() activeRoomTitle = '';
  @Input() activeRoomSummary = '';
  @Input() logoUrl: string | null = null;
  @Input() canOpenCatalog = false;
  @Input() catalogOpen = false;
  @Input() hasUsedProducts = false;
  @Input() hasActiveProduct = false;
  @Input() adjustmentOpen = false;
  @Input() canSendToEstimator = false;

  @Output() back = new EventEmitter<void>();
  @Output() roomUpload = new EventEmitter<Event>();
  @Output() toggleCatalog = new EventEmitter<void>();
  @Output() toggleAdjustment = new EventEmitter<void>();
  @Output() requestQuote = new EventEmitter<void>();
  @Output() sendToEstimator = new EventEmitter<void>();
  @Output() toggleOrientation = new EventEmitter<void>();
}
